// Pure decision for what happens when a bell notification is clicked.
//
// Given the clicked notification item and the scenario the user is currently
// viewing (the route's :id param on a player scenario route, or null on
// neutral pages), returns where to navigate and whether a confirmation dialog
// is required first.
//
//   { target: string|null, needsConfirm: boolean }
//
// - No scenarioId on the item → not navigable (target: null).
// - target deep-links to the scenario's notification center, focusing the item.
// - needsConfirm only when the user is inside a *different* scenario.
export function resolveNotificationNavigation(item, currentScenarioId) {
  if (!item?.scenarioId) {
    return { target: null, needsConfirm: false }
  }
  const target = `/scenarios/${item.scenarioId}/notifications?focus=${encodeURIComponent(item.id)}`
  const needsConfirm = currentScenarioId != null && currentScenarioId !== item.scenarioId
  return { target, needsConfirm }
}
